import { Card, CurrencyFormat, Icon, Spinner } from '@/components/generic';
import { formatUnitsToAmount } from '@/utils';
import { bitcoinChain, useChainStore } from '@package/smart-wallet';
import { useGetTokenBalances } from '@package/smart-wallet/hooks';
import { useTranslation } from 'react-i18next';

export const Overview = () => {
  const { t } = useTranslation(); // ⭐ FALTABA ESTO
  const chainId = useChainStore((state) => state.chainId);

  const { isLoading, tokenSymbol, tokenAmount, tokenDecimals, tokens } =
    useGetTokenBalances({ allTokens: true });

  return (
    <Card title={t('wallet.overview')}>
      <div className='pt-1'>
        <div className='flex mb-4 p-1.5 border border-s-subtle rounded-4xl bg-b-depth2'>
          <div
            className={`group flex-1 px-12 py-8 rounded-3xl cursor-pointer transition-all max-2xl:p-6 max-xl:pr-3 max-md:p-4`}
          >
            <div
              className={`flex items-center gap-3 mb-2 text-sub-title-1 transition-colors group-hover:text-t-primary max-md:mb-3 max-md:text-sub-title-2`}
            >
              <Icon
                className={`transition-colors fill-t-primary`}
                name={'wallet'}
              />
              <div className=''>{t('wallet.balance')}</div>
            </div>
            <div className='flex items-center gap-4 max-md:flex-col max-md:items-stretch max-md:gap-1'>
              {isLoading ? (
                <Spinner className='bg-transparent ' />
              ) : (
                <CurrencyFormat
                  className='text-4xl sm:text-5xl lg:text-6xl'
                  currency={tokenSymbol === 'BTC' ? '' : undefined}
                  decimalAmount={
                    tokenSymbol === 'BTC' && tokenAmount
                      ? tokenDecimals
                      : undefined
                  }
                  value={Number(
                    formatUnitsToAmount({
                      string: tokenAmount || '0',
                      decimalToken: tokenDecimals,
                    }),
                  )}
                />
              )}
            </div>
          </div>

          <div
            className={`group flex-1 px-12 py-8 rounded-3xl cursor-pointer transition-all max-2xl:p-6 max-xl:pr-3 max-md:p-4`}
          >
            <div
              className={`flex items-center gap-3 mb-2 text-sub-title-1 transition-colors group-hover:text-t-primary max-md:mb-3 max-md:text-sub-title-2`}
            >
              <Icon
                className={`transition-colors fill-t-primary`}
                name={'promote'}
              />
              <div className=''>{t('wallet.token_symbol')}</div>
            </div>

            <div className='flex items-center gap-4 max-md:flex-col max-md:items-stretch max-md:gap-1'>
              {isLoading ? (
                <Spinner className='bg-transparent ' />
              ) : (
                <span className='!text-4xl md:!text-5xl lg:text-6xl'>
                  {tokenSymbol}
                </span>
              )}
            </div>
          </div>
        </div>

        {chainId !== bitcoinChain.id && (
          <div className='px-1'>
            <h3 className='text-sm font-semibold text-t-secondary mb-3 px-3'>
              Supported Tokens
            </h3>

            <div className='flex flex-col gap-2'>
              {isLoading ? (
                <div className='flex justify-center py-4'>
                  <Spinner className='bg-transparent' />
                </div>
              ) : (
                tokens.map((token, index) => (
                  <div
                    key={token.symbol ?? index}
                    className='flex items-center justify-between p-3 rounded-lg bg-b-surface2 hover:bg-b-surface3 transition-colors'
                  >
                    <div className='flex items-center gap-3'>
                      {token.icon && (
                        <img
                          src={token.icon}
                          alt={token.symbol}
                          className='w-8 h-8 rounded-full'
                        />
                      )}
                      <div>
                        <div className='font-medium text-t-primary'>
                          {token.symbol}
                        </div>
                        {token.isPrimary && (
                          <span className='text-xs text-t-tertiary'>
                            Primary
                          </span>
                        )}
                      </div>
                    </div>

                    <div className='text-right'>
                      <CurrencyFormat
                        className='text-base font-medium text-t-primary'
                        postfix={token.symbol}
                        currency=''
                        decimalAmount={
                          token.symbol?.includes('USD') ? 4 : token.decimals
                        }
                        value={Number(
                          formatUnitsToAmount({
                            string: token.amount,
                            decimalToken: token.decimals,
                          }),
                        )}
                      />
                    </div>
                  </div>
                ))
              )}
            </div>
          </div>
        )}
      </div>
    </Card>
  );
};
